import { Reveal } from "./Reveal";
import { GALLERY } from "../data/content";

export const Gallery = () => {
  return (
    <section
      id="gallery"
      data-testid="gallery-section-container"
      className="py-20 md:py-28 px-4 sm:px-8 lg:px-16 bg-[#EAE0D5]"
    >
      <div className="max-w-7xl mx-auto">
        <Reveal>
          <div className="text-center max-w-2xl mx-auto mb-14">
            <p className="text-xs sm:text-sm uppercase tracking-[0.2em] font-semibold text-[#C15B3D] mb-4">
              Visual Tour
            </p>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#1F291E] leading-tight">
              {GALLERY.title}
            </h2>
            <p className="mt-5 text-lg text-[#5C6B5A]">{GALLERY.subtitle}</p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {GALLERY.images.map((img, i) => (
            <Reveal key={img.title} delay={(i % 3) * 0.1}>
              <figure
                data-testid={`gallery-grid-item-${i}`}
                className="group relative overflow-hidden rounded-2xl shadow-md cursor-pointer"
              >
                <img
                  src={img.url}
                  alt={img.title}
                  className="w-full h-64 object-cover transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#142415]/85 via-[#142415]/10 to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-95" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-6 translate-y-2 opacity-90 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  <span className="text-[11px] uppercase tracking-[0.2em] text-[#EAC9B8] font-semibold">
                    {img.category}
                  </span>
                  <h3 className="font-serif text-xl text-white mt-1">
                    {img.title}
                  </h3>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

      </div>
    </section>
  );
};
